import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';

import Checkbox from '../../components/forms/Checkbox';
import { wrapEventHandler } from '../../utils/handlers';

const BulkTrailEditTrailsList = ({
  activeIndex,
  alerts,
  changes,
  handleTrailAlertClick,
  handleTrailSelectChange,
  handleTrailTagClick,
  highlightedTag,
  selectedTrails,
  tabs,
  trailHasTag,
  trails
}) => {
  const renderTagTrailChanges = (trail, changes) => {
    if (changes[trail.id] && changes[trail.id].tags) {
      return [
        ...changes[trail.id].tags.add.map(uid => createTrailTagButton(trail, uid, true)),
        ...changes[trail.id].tags.sub.map(uid => createTrailTagButton(trail, uid, false))
      ];
    }
    return null;
  };

  const renderHighlightedTag = (trail, highlightedTag) => {
    if (highlightedTag && trailHasTag(trail, highlightedTag.uid)) {
      return (
        <span className="tag">
          <span className={`small rounded active ${styles.highlighted}`}>{highlightedTag.name}</span>
        </span>
      );
    }
    return null;
  };

  const renderListOfAnchors = anchors => {
    let list = [];
    const count = anchors.length;
    anchors.forEach((anchor, i) => {
      list.push(anchor);
      if (i < count - 1) {
        list.push(<span key={`spacer-${i}`}>, </span>);
      }
    });
    return list;
  };

  const renderTrailAlertAnchor = (trail, alertId, isAdd) => {
    const alert = alerts.find(a => a.id === alertId);
    const displayText = alert && alert.shortName || `${alertId}.`;
    return <a key={alertId} onClick={wrapEventHandler(() => handleTrailAlertClick(trail, alertId, isAdd))}>{displayText}</a>;
  };

  const renderTrailAlertsChanges = (trail, changes) => {
    let added = [];
    let removed = [];
    if (changes[trail.id] && changes[trail.id].alerts) {
      added = changes[trail.id].alerts.add;
      removed = changes[trail.id].alerts.sub;
    }
    const unchanged = trail.alerts.filter(id => !added.includes(id) && !removed.includes(id));

    return (
      <span className={styles.alertsChanges}>
        {unchanged.length > 0 && <span>{
          renderListOfAnchors(unchanged.map(id => renderTrailAlertAnchor(trail, id, false)))
        }</span>}
        {removed.length > 0 && <span>➖{
          renderListOfAnchors(removed.map(id => renderTrailAlertAnchor(trail, id, true)))
        }</span>}
        {added.length > 0 && <span>➕{
          renderListOfAnchors(added.map(id => renderTrailAlertAnchor(trail, id, false)))
        }</span>}
      </span>
    );
  };

  const createTrailTagButton = (trail, tagUid, isAdd) => {
    const classes = `btn-slim brown option-select ${isAdd ? '' : styles.tagDelete}`;
    return (
      <a key={tagUid} className={classes} onClick={() => handleTrailTagClick(trail, tagUid, isAdd)}>
        {tagUid}
      </a>
    );
  };

  const trailRows = trails.map(trail => {
    let showChanges = null;
    let showHighlightedTag = null;
    switch (tabs[activeIndex].key) {
      case "tags":
        showChanges = renderTagTrailChanges(trail, changes);
        showHighlightedTag = renderHighlightedTag(trail, highlightedTag);
        break;
      case "alerts":
        showChanges = renderTrailAlertsChanges(trail, changes);
        break;
    }
    return (
      <tr key={trail.id}>
        <td>
          <Checkbox
            handleChange={() => handleTrailSelectChange(trail.id)}
            checked={selectedTrails[trail.id]}
            label={`${trail.id}`}
          />
        </td>
        <td><a href={`/trail/${trail.slug}`} target="_blank">{trail.name}</a></td>
        <td>{showHighlightedTag}{showChanges}</td>
      </tr>
    );
  })

  return (
    <table>
      <tbody>
        {trailRows}
      </tbody>
    </table>
  );
};

BulkTrailEditTrailsList.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  changes: PropTypes.object.isRequired,
  handleTrailAlertClick: PropTypes.func.isRequired,
  handleTrailSelectChange: PropTypes.func.isRequired,
  handleTrailTagClick: PropTypes.func.isRequired,
  highlightedTag: PropTypes.object,
  selectedTrails: PropTypes.object.isRequired,
  tabs: PropTypes.array.isRequired,
  trailHasTag: PropTypes.func.isRequired,
  trails: PropTypes.array.isRequired
};

export default BulkTrailEditTrailsList;
